"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutTextColumn = void 0;
var derive_font_metrics_1 = require("./derive-font-metrics");
var legacy_2_1 = require("./legacy-2");
var units_1 = require("./units");
var layoutTextColumn = function (_a) {
    var text = _a.text, width = _a.width, fontMetrics = _a.fontMetrics, maxFontSize = _a.maxFontSize, measureTextWidth = _a.measureTextWidth;
    var fontSize = maxFontSize;
    var paragraphs = (0, legacy_2_1.wrapText)({
        text: text,
        width: width,
        measureTextWidth: function (text) { return measureTextWidth({ text: text, fontSize: fontSize }); },
    });
    var lineHeight = (0, derive_font_metrics_1.deriveLineHeight)({
        fontMetrics: fontMetrics,
        fontSize: (0, units_1.convertPointsToMM)(fontSize),
    });
    var lineCount = paragraphs.reduce(function (acc, paragraph) { return acc + paragraph.length; }, 0);
    var height = lineCount * lineHeight;
    return { height: height };
};
exports.layoutTextColumn = layoutTextColumn;
